var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
var appKey = "kid_rkMvaFdSX";
var appSecret = "a6ebc734c55d4407b0442a0b17d0a91e";
var kinveyBaseUrl = "https://baas.kinvey.com/";
var getAllUrl = kinveyBaseUrl + "appdata" + "/" + appKey + "/flats";
//POST /user/:appKey/ HTTP/1.1
var KinveyRemoteServiceService = /** @class */ (function () {
    function KinveyRemoteServiceService(http) {
        this.http = http;
    }
    //MAKE AUTH
    KinveyRemoteServiceService.prototype.makeAuth = function (type) {
        return type === "basic"
            ? "Basic " + btoa(appKey + ":" + appSecret)
            : "Kinvey " + localStorage.getItem("authtoken");
    };
    //IS AUTH
    KinveyRemoteServiceService.prototype.isAuth = function () {
        return localStorage.getItem("authtoken") !== null;
    };
    //SAVE SESSION
    KinveyRemoteServiceService.prototype.saveSession = function (userData) {
        localStorage.setItem("authtoken", userData._kmd.authtoken);
        localStorage.setItem("username", userData.username);
        localStorage.setItem("userId", userData._id);
        localStorage.setItem("picUrl", userData.profilePic);
        localStorage.setItem("isAdmin", userData.isAdmin);
    };
    //POST
    KinveyRemoteServiceService.prototype.post = function (url, data, auth) {
        return this.http.post(url, data, {
            headers: { authorization: this.makeAuth(auth) }
        });
    };
    //PUT
    KinveyRemoteServiceService.prototype.put = function (url, data, auth) {
        return this.http.put(url, data, {
            headers: { authorization: this.makeAuth(auth) }
        });
    };
    //GET
    KinveyRemoteServiceService.prototype.get = function (url, auth) {
        return this.http.get(url, {
            headers: { authorization: this.makeAuth(auth) }
        });
    };
    //DELETE
    KinveyRemoteServiceService.prototype.delete = function (url, id, auth) {
        return this.http.delete(url, {
            headers: { authorization: this.makeAuth(auth) }
        });
    };
    //REGISTER
    KinveyRemoteServiceService.prototype.register = function (username, password, profilePic) {
        //POST /user/:appKey/ HTTP/1.1
        var obj = {
            username: username,
            password: password,
            profilePic: "https://boygeniusreport.files.wordpress.com/2016/05/scared-surprised-cat-face.jpg?quality=98&strip=all&w=782"
        };
        var url = kinveyBaseUrl + "user" + "/" + appKey + "/";
        var data = obj;
        return this.post(url, data, "basic");
    };
    //LOGIN
    KinveyRemoteServiceService.prototype.login = function (username, password) {
        //POST /user/:appKey/login HTTP/1.1
        var obj = { username: username, password: password };
        var url = kinveyBaseUrl + "user" + "/" + appKey + "/login";
        var data = obj;
        return this.post(url, data, "basic");
    };
    //LOGOUT
    KinveyRemoteServiceService.prototype.logout = function () {
        //POST /user/:appKey/_logout HTTP/1.1
        var url = kinveyBaseUrl + "user" + "/" + appKey + "/_logout";
        var data = null;
        return this.post(url, data, "kinvey");
    };
    //UPDATE USER
    KinveyRemoteServiceService.prototype.updateUser = function (username, password, id, profilePic) {
        // PUT/user/:appKey/:id HTTP / 1.1
        var obj = { username: username, profilePic: profilePic };
        var url = kinveyBaseUrl + "user" + "/" + appKey + "/" + id;
        var data = obj;
        return this.put(url, data, "kinvey");
    };
    //CREATE CAT
    KinveyRemoteServiceService.prototype.CreateCat = function (name, breed, age, contactNumber, information, imgUrl, imgUrl2, imgUrl3, imgUrl4, vaccinated, castrated, city) {
        // /appdata/:appKey/:collectionName HTTP/1.1
        var obj = {
            name: name,
            breed: breed,
            age: age,
            contactNumber: contactNumber,
            information: information,
            imgUrl: imgUrl,
            imgUrl2: imgUrl2,
            imgUrl3: imgUrl3,
            imgUrl4: imgUrl4,
            vaccinated: vaccinated,
            castrated: castrated,
            city: city
        };
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Cats";
        var data = obj;
        return this.post(url, data, "kinvey");
    };
    //CREATE MESSAGE
    KinveyRemoteServiceService.prototype.CreateMessage = function (message, receiver, sender, open, senderName, madeDate, catName) {
        // /appdata/:appKey/:collectionName HTTP/1.1
        var obj = {
            message: message,
            receiver: receiver,
            sender: sender,
            open: open,
            senderName: senderName,
            madeDate: madeDate,
            catName: catName
        };
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Messages";
        var data = obj;
        return this.post(url, data, "kinvey");
    };
    //UPDATE MESSAGE
    KinveyRemoteServiceService.prototype.UpdateMessage = function (catName, senderName, open, sender, receiver, message, madeDate, id) {
        ///appdata/:appKey/:collectionName/:id HTTP/1.1
        var obj = {
            catName: catName,
            senderName: senderName,
            open: open,
            sender: sender,
            receiver: receiver,
            message: message,
            madeDate: madeDate
        };
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Messages" + "/" + id;
        var data = obj;
        return this.put(url, data, "kinvey ");
    };
    //DELETE MESSAGE
    KinveyRemoteServiceService.prototype.DeleteMessage = function (id) {
        //DELETE /appdata/:appKey/:collectionName/:id?query=... HTTP/1.1
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Messages" + "/" + id;
        return this.delete(url, id, "kinvey ");
    };
    //GET ALL CATS
    KinveyRemoteServiceService.prototype.GetAllCats = function () {
        // /appdata/:appKey/:collectionName HTTP/1.1
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Cats";
        return this.get(url, "kinvey");
    };
    //GET ALL USERS
    KinveyRemoteServiceService.prototype.GetAllUsers = function () {
        // GET /user/:appKey/:id HTTP/1.1
        // return remote.get('appdata', "Products", 'kinvey');
        var url = kinveyBaseUrl + "user" + "/" + appKey + "/";
        return this.get(url, "kinvey");
    };
    //DELETE USER
    KinveyRemoteServiceService.prototype.DeleteUser = function (id) {
        //DELETE /user/:appKey/:id HTTP/1.1
        var url = kinveyBaseUrl + "user" + "/" + appKey + "/" + id;
        return this.delete(url, null, "kinvey");
    };
    //GET CAT BY ID
    KinveyRemoteServiceService.prototype.GetCatById = function (id) {
        //GET /appdata/:appKey/:collectionName/:id
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Cats" + "/" + id;
        return this.get(url, "kinvey");
    };
    //UPDATE CAT BY ID
    KinveyRemoteServiceService.prototype.UpdateCat = function (name, breed, age, contactNumber, information, imgUrl, id) {
        ///appdata/:appKey/:collectionName/:id HTTP/1.1
        var obj = { name: name, breed: breed, age: age, contactNumber: contactNumber, information: information, imgUrl: imgUrl };
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Cats" + "/" + id;
        var data = obj;
        return this.put(url, data, "kinvey ");
    };
    //DELETE CAT
    KinveyRemoteServiceService.prototype.deleteCat = function (id) {
        //DELETE /appdata/:appKey/:collectionName/:id?query=... HTTP/1.1
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Cats" + "/" + id;
        return this.delete(url, id, "kinvey");
    };
    //GET MESSAGES
    KinveyRemoteServiceService.prototype.GetAllMessages = function () {
        // /appdata/:appKey/:collectionName HTTP/1.1
        // return remote.get('appdata', "Products", 'kinvey');
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Messages";
        return this.get(url, "kinvey");
    };
    //GET MESSAGES
    KinveyRemoteServiceService.prototype.GetAllMessagesById = function (id) {
        // /appdata/:appKey/:collectionName HTTP/1.1
        // return remote.get('appdata', "Products", 'kinvey');
        var url = kinveyBaseUrl + "Messages" + "/" + appKey + "/" + id;
        return this.get(url, "kinvey");
    };
    //GET MESSAGE BY ID
    KinveyRemoteServiceService.prototype.GetMessageById = function (id) {
        //GET /appdata/:appKey/:collectionName/:id
        //let url = kinveyBaseUrl + 'appdata' + "/" + appKey + "/" + "Cats" + "/" + id
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Messages" + "/" + id;
        return this.get(url, "kinvey");
    };
    //GET USER BY ID
    KinveyRemoteServiceService.prototype.GetUserById = function (id) {
        //GET /user/:appKey/:id HTTP/1.1
        var url = kinveyBaseUrl + "user" + "/" + appKey + "/" + id;
        return this.get(url, "kinvey");
    };
    //DELETE MESSAGE BY ID
    KinveyRemoteServiceService.prototype.DeleteMessageById = function (id) {
        var url = kinveyBaseUrl + "appdata" + "/" + appKey + "/" + "Messages" + "/" + id;
        return this.delete(url, id, "kinvey");
    };
    KinveyRemoteServiceService = __decorate([
        Injectable({
            providedIn: "root"
        }),
        __metadata("design:paramtypes", [HttpClient])
    ], KinveyRemoteServiceService);
    return KinveyRemoteServiceService;
}());
export { KinveyRemoteServiceService };
//# sourceMappingURL=kinvey-remote-service.service.js.map